<template>
  <v-layout column style="position: absolute; overflow: hidden !important">
    <router-view/>


    <!-- <v-dialog max-width="400" persistent v-model="sessionData.showLoginDialog">
      <Login :verifiedUser="verifiedUser" :verifiedUserData="verifiedUserData"
          :projects="projects" :sessionData="sessionData"/>
    </v-dialog>
    <v-dialog max-width="400" persistent v-model="sessionData.showSubscribeDialog">
      <Subscribe :verifiedUser="verifiedUser" :verifiedUserData="verifiedUserData"
          :projects="projects" :sessionData="sessionData"/>
    </v-dialog>
    <v-dialog max-width="100vmin"  v-model="sessionData.showImpressumDialog">
      <v-card class="elevation-12">
        <v-toolbar dark>
          <v-toolbar-title>Legal Notice</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-layout column justify-center align-center>
        <span style="font-weight: bold">Contact Information</span>
        <span style="text-align: center">Janosch Dlouhy and Marco Binninger</span>
        <span style="text-align: center">Alte Bergstraße 436</span>
        <span style="text-align: center">86899 Landsberg am Lech</span>
        <span><br/></span>
        <span style="text-align: center">E-Mail: info@takting.com</span>
        <span><br/></span>
        <span style="font-weight: bold">Disclaimer:</span>
        <span style="text-align: center">All rights reserved, unless expressly stated otherwise. All contents merely provide a non-binding overview of the company, the product, the vision and our goals. For the correctness, completeness or topicality of the data no guarantee is taken over.</span>
        <span><br/></span>
        <span style="font-weight: bold">Legal Information:</span>
        <span style="text-align: center">The contents of this website are regularly adapted. We reserve the right to make changes or additions to the information provided without prior notice. We are not liable for direct or indirect damages arising from or in connection with information provided on this website. The content of this website is protected by copyright.</span>
        <span><br/></span>
        <span style="font-weight: bold">Data Protection:</span>
        <span style="text-align: center">We refer to our privacy policy. If you have any questions, please contact us at the above contact details.</span>
          </v-layout>
        </v-card-text>

      </v-card>
    </v-dialog> -->

    <!-- mobile buttons -->
    <template v-if="$vuetify.breakpoint.smAndDown">
      <div class="display-flex">
        <div style="width: 50%; height: 50px; padding: 5px 2.5px 5px 5px">
          <v-btn
          width="100%"
          height="100%"
          @click="doArrowLeft()"
          >
          <v-icon class="mr-1">share</v-icon>
          {{ $t(Home.Home.Register) }}
        </v-btn>
        </div>
        <div style="width: 50%; height: 50px; padding: 5px 5px 5px 2.5px">
          <v-btn
            width="100%"
            height="100%"
            @click="doArrowRight()"
            >
            <v-icon class="mr-1">login</v-icon>
            Login
          </v-btn>
      </div>
      </div>
    </template>

    <template>
      <iPhonePWAHint v-if="iPhonePWAHint()"/>
    </template>

    <!-- Logo -->
    <div id="logo" class="logo" :style='getLogoOpacity()'>
      <div class="square square1"></div>
      <div class="square square2"></div>
      <div class="square square3"></div>
      <div class="square square4"></div>
      <div class="square square5"></div>
      <div class="square square6"></div>
      <div class="square square7"></div>
      <div class="square square8"></div>
      <div class="square square9"></div>
      <div class="square square10"></div>
      <div class="square square11"></div>
      <div class="square square12"></div>
      <div class="square square13"></div>
      <div class="square square14"></div>
      <div class="square square15"></div>
      <div class="square square16"></div>
      <div class="square square17"></div>
      <div class="square square18"></div>
      <div class="square square19"></div>
      <div class="square square20"></div>
      <div class="square square21"></div>
      <!-- <span class="announcement primary--text">{{ $t("Home.Home.Apply[0]") }} <i>{{ $t("Home.Home.Apply[1]") }}</i> {{ $t("Home.Home.Apply[2]") }}</span> -->
    </div>


    <template v-if="!$vuetify.breakpoint.smAndDown">
    <!-- Navigation Arrows -->

      <div id="arrowleft"  class="arrowleft" :style="`opacity: ${this.opacityArrowLeft}`"
        @click="doArrowLeft()" @mouseover="opacityArrowLeft = 1" @mouseleave="opacityArrowLeft = 0.5">
        <div id="left1" class="arrow arrow1"/>
        <div id="left2" class="arrow arrow2"/>
        <div id="subscribe" class="subscribe">{{ $t("Home.Home.Register") }}</div>
      </div>
      <div id="arrowright" class="arrowright" :style="`opacity: ${this.opacityArrowRight}`"
      @click="doArrowRight()" @mouseover="opacityArrowRight = 1" @mouseleave="opacityArrowRight = 0.5">
        <div id="right1" class="arrow arrow1"/>
        <div id="right2" class="arrow arrow2"/>
        <div id="login" class="login">Login</div>
      </div>
      <div id="arrowdown" class="arrowdown" :style="styleArrowDown()"
      @click="doArrowDown()" @mouseover="mouseOverDown()" @mouseleave="mouseLeaveDown()">
        <div id="down1" class="arrow arrow1"/>
        <div id="down2" class="arrow arrow2"/>
        <div id="more" class="more">{{ $t("Home.Home.More") }}</div>
      </div>
      <div id="arrowup" class="arrowup" :style="`opacity: ${this.opacityArrowUp}`"
      @click="doArrowUp()" @mouseover="mouseOverUp()" @mouseleave="mouseLeaveUp()">
        <div id="up1" class="arrow arrow1"/>
        <div id="up2" class="arrow arrow2"/>
        <div id="back" class="back">Back</div>
      </div>

    <!-- Background Image -->
    <div class="imgContainer" :style="getImageOpacityTranslate()">
      <img center class="image" :style="this.opacityStart" src="https://api.takting.com/img/frontpage_start.png"/>
    </div>
    <div class="imgContainer" :style="getImageOpacityTranslate()">
      <img class="image" :style="this.opacityTakt" src="https://api.takting.com/img/frontpage_takt.png"/>
    </div>
    <div class="imgContainer" :style="getImageOpacityTranslate()">
      <img class="image" :style="this.opacityCraftsman" src="https://api.takting.com/img/frontpage_craftsman.png"/>
    </div>
    <div class="imgContainer" :style="getImageOpacityTranslate()">
      <img class="image" :style="this.opacityConstruction" src="https://api.takting.com/img/frontpage_construction2.png"/>
    </div>
    <div class="imgContainer" :style="getImageOpacityTranslate()">
      <img class="image" :style="this.opacityTime" src="https://api.takting.com/img/frontpage_time2.png"/>
    </div>
    <div class="imgContainer" :style="getImageOpacityTranslate()">
      <img class="image" :style="this.opacityValue" src="https://api.takting.com/img/frontpage_value2.png"/>
    </div>

    <!-- Selection Waggons -->
    <!-- Trainhead -->
    <div class="coverflow" :style="this.trainMargin">
      <v-card @click="showWaggons()" class="train-start-frontpage" color="#616161"
      :style="getWaggonOpacity('0.3s','Train')"/>
      <!-- Waggons -->
      <v-card
      @click="setWaggonActive('Takt')" class="taktplan-waggon-frontpage" color="#616161"
      :style="getWaggonOpacity('0.35s','Takt')">
      <v-layout justify-center align-center fill-height>
        <v-card class="taktplan-work_package1-frontpage" :syle="this.workPackageWidthTakt"
          color="indigo lighten-1"
           disabled label>
           <v-layout justify-center align-center fill-height>
             <span :style="this.workPackageFontSizeColorTakt">Takt</span>
           </v-layout>
         </v-card>
        </v-layout>
      </v-card>
      <v-card @click="setWaggonActive('Craftsman')" class="taktplan-waggon-frontpage" color="#616161"
      :style="getWaggonOpacity('0.4s','Craftsman')">
      <v-layout justify-center align-center fill-height>
        <v-card class="taktplan-work_package1-frontpage" :syle="this.workPackageWidthCraftsman"
          color="green lighten-1"
           disabled label>
           <v-layout justify-center align-center fill-height>
             <span :style="this.workPackageFontSizeColorCraftsman">Craftsman</span>
           </v-layout>
         </v-card>
        </v-layout>
      </v-card>
      <v-card
      @click="setWaggonActive('Construction')" class="taktplan-waggon-frontpage" color="#616161"
      :style="getWaggonOpacity('0.45s','Construction')">
      <v-layout justify-center align-center fill-height>
        <v-card class="taktplan-work_package1-frontpage" :syle="this.workPackageWidthConstruction"
          color="yellow lighten-1"
           disabled label>
           <v-layout justify-center align-center fill-height>
             <span :style="this.workPackageFontSizeColorConstruction">Construction</span>
           </v-layout>
         </v-card>
        </v-layout>
      </v-card>
      <v-card
      @click="setWaggonActive('Time')" class="taktplan-waggon-frontpage" color="#616161"
      :style="getWaggonOpacity('0.5s','Time')">
      <v-layout justify-center align-center fill-height>
        <v-card class="taktplan-work_package1-frontpage" :syle="this.workPackageWidthTime"
          color="red lighten-1"
           disabled label>
           <v-layout justify-center align-center fill-height>
             <span :style="this.workPackageFontSizeColorTime">Time</span>
           </v-layout>
         </v-card>
        </v-layout>
      </v-card>
      <v-card @click="setWaggonActive('Value')" class="taktplan-waggon-frontpage" color="#616161"
      :style="getWaggonOpacity('0.55s','Value')">
      <v-layout justify-center align-center fill-height>
        <v-card class="taktplan-work_package1-frontpage" :syle="this.workPackageWidthValue"
          color="purple lighten-1"
           disabled label>
           <v-layout justify-center align-center fill-height>
             <span :style="this.workPackageFontSizeColorValue">Value</span>
           </v-layout>
         </v-card>
        </v-layout>
      </v-card>
      <!-- Trainend -->
      <v-card @click="showWaggons()" class="train-end-frontpage" color="#616161"
      :style="getWaggonOpacity('0.6s','Train')"/>
    </div>

    <!-- Infobox -->
    <v-card class="infobox-waggon-frontpage" color="#616161"
    :style="`${getInfoBoxOpacity('Takt')}; right: 9vmin`">
    <v-layout justify-center align-center fill-height>
      <v-card class="infobox-work_package1-frontpage" :syle="this.workPackageWidthValue"
        color="indigo lighten-1"
         disabled label>
         <v-layout column justify-center align-center>
           <span class="infoBoxHeader">TAKT</span>
           <span class="infoBoxSubheader">value.process.time</span>
           <span class="infoBoxText">TAKT combines the three dimensions</span>
           <span class="infoBoxText">value, process and time. Human systems</span>
           <span class="infoBoxText">need TAKT for efficiency and balance.</span>
           <span class="infoBoxText">Music shows that Takt is a human way to</span>
           <span class="infoBoxText">create synchrony.</span>
         </v-layout>
       </v-card>
      </v-layout>
    </v-card>
    <v-card class="infobox-waggon-frontpage" color="#616161"
    :style="`${getInfoBoxOpacity('Craftsman')}; left: 9vmin`">
    <v-layout justify-center align-center fill-height>
      <v-card class="infobox-work_package1-frontpage" :syle="this.workPackageWidthValue"
        color="green lighten-1"
         disabled label>
         <v-layout column justify-center align-center>
           <span class="infoBoxHeader">CRAFTSMAN</span>
           <span class="infoBoxSubheader">honored.connected</span>
           <span class="infoBoxText">In the past the construction sector has been</span>
           <span class="infoBoxText">a proud and strong industry. Over the last</span>
           <span class="infoBoxText">centuries the industry has lost these</span>
           <span class="infoBoxText">qualities. TAKT connects craftsmen to build</span>
           <span class="infoBoxText">powerful and honored teams.</span>
         </v-layout>
       </v-card>
      </v-layout>
    </v-card>
    <v-card class="infobox-waggon-frontpage" color="#616161"
    :style="`${getInfoBoxOpacity('Construction')}; left: 9vmin`">
    <v-layout justify-center align-center fill-height>
      <v-card class="infobox-work_package1-frontpage" :syle="this.workPackageWidthValue"
        color="yellow lighten-1"
         disabled label>
         <v-layout column justify-center align-center>
           <span class="infoBoxHeader" style="color: #212121">CONSTRUCTION</span>
           <span class="infoBoxSubheader" style="color: #212121">free.simple.transparent</span>
           <span class="infoBoxText" style="color: #212121">TAKT enables construction sectors to be a</span>
           <span class="infoBoxText" style="color: #212121">free and prosperous industry that regulates</span>
           <span class="infoBoxText" style="color: #212121">itself on its own through clear transparency.</span>
           <span class="infoBoxText" style="color: #212121">Because we truly believe in this idea</span>
           <span class="infoBoxText" style="color: #212121">… this app will be free of charge for everybody.</span>
         </v-layout>
       </v-card>
      </v-layout>
    </v-card>
    <v-card class="infobox-waggon-frontpage" color="#616161"
    :style="`${getInfoBoxOpacity('Time')}; left: 9vmin`">
    <v-layout justify-center align-center fill-height>
      <v-card class="infobox-work_package1-frontpage" :syle="this.workPackageWidthValue"
        color="red lighten-1"
         disabled label>
         <v-layout column justify-center align-center>
           <span class="infoBoxHeader">TIME</span>
           <span class="infoBoxSubheader">safe.efficent.balanced</span>
           <span class="infoBoxText">Overrunning deadlines occures in</span>
           <span class="infoBoxText">construction daily. TAKT stabilizes and</span>
           <span class="infoBoxText">optimizes processes to gain time for</span>
           <span class="infoBoxText">quality.</span>
           <span class="infoBoxText">How much time do you need?</span>
           <span class="infoBoxText">Don’t get pushed anymore … choose!</span>
         </v-layout>
       </v-card>
      </v-layout>
    </v-card>
    <v-card class="infobox-waggon-frontpage" color="#616161"
    :style="`${getInfoBoxOpacity('Value')}; right: 9vmin`">
    <v-layout justify-center align-center fill-height>
      <v-card class="infobox-work_package1-frontpage" :syle="this.workPackageWidthValue"
        color="purple lighten-1"
         disabled label>
         <v-layout column justify-center align-center>
           <span class="infoBoxHeader">VALUE</span>
           <span class="infoBoxSubheader">countable.measurable.agile</span>
           <span class="infoBoxText">Our aim is to create more value for all</span>
           <span class="infoBoxText">construction participants. Value must be</span>
           <span class="infoBoxText">definable, countable and measurable.</span>
           <span class="infoBoxText">Construction changes with TAKT from</span>
           <span class="infoBoxText">secure business to value business.</span>
         </v-layout>
       </v-card>
      </v-layout>
    </v-card>
    <div style="margin-top: 120vh" id="endOfPage"></div>
  </template>
</v-layout>
</template>

<script>
import iPhonePWAHint from '@/components/AppLayout/iPhonePWAHint.component.vue'
export default {
  components: {
    iPhonePWAHint
  },
    props: ['sessionData', 'verifiedUser', 'verifiedUserData', 'projects'],
    data: () => ({
      versionNumber: [0, 13, 0],
      popup: true, // can be deleted soon!
      scrolled: 0,
      scrollDirection: "up",
      opacityStart: "opacity: 1",
      opacityTakt: "opacity: 0",
      opacityCraftsman: "opacity: 0",
      opacityConstruction: "opacity: 0",
      opacityTime: "opacity: 0",
      opacityValue: "opacity: 0",
      // width
      widthTakt: "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
      widthCraftsman: "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
      widthConstruction: "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
      widthTime: "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
      widthValue: "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
      // work_packages
      workPackageWidthTakt: 'width: 12.81vmin',
      workPackageWidthCraftsman: 'width: 12.81vmin',
      workPackageWidthConstruction: 'width: 12.81vmin',
      workPackageWidthTime: 'width: 12.81vmin',
      workPackageWidthValue: 'width: 12.81vmin',
      // Font
      workPackageFontSizeColorTakt: 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold',
      workPackageFontSizeColorCraftsman: 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold',
      workPackageFontSizeColorConstruction: 'color: #212121; font-size: 2.145vmin; font-weight: bold',
      workPackageFontSizeColorTime: 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold',
      workPackageFontSizeColorValue: 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold',
      // trainMargin
      // marginTakt: 'margin-left: 0.4vmin; margin-right: 0.4vmin',
      // marginCraftsman: 'margin-left: 0.4vmin; margin-right: 0.4vmin',
      // marginConstruction: 'margin-left: 0.4vmin; margin-right: 0.4vmin',
      // marginTime: 'margin-left: 0.4vmin; margin-right: 0.4vmin',
      // marginValue: 'margin-left: 0.4vmin; margin-right: 0.4vmin',
      opacityArrowLeft: 0.5,
      opacityArrowRight: 0.5,
      opacityArrowUp: 0,
      opacityArrowDown: 0.5,

      scrolling: 0,
      imageOpacity: 0,
      imageTranslate: "translateY(1000px)",
      logoOpacity: 1,
      waggonOpacity: 0,
      waggonTranslate: "translateY(200px)",
      img: "https://api.takting.com/img/frontpage_start.png",
      activeWaggon: 'Takt',
      trainOpen: 'true',
      trainMargin: 'margin-left: -50vmin',
      // waggonWidth: 'width: 14.4vmin',
      // workPackageWidth: 'width: 12.81vmin',
      // workPackageFontSize: 'color: #F5F5F5; font-size: 2.145vmin',
    }),

  watch: {
    scrolling: function (val) {
      var self = this
      if (val === 1) {
        setTimeout(function(){
          self.scrolling = 0
        }, 2000);
      }
    },
  },

  methods: {
    iPhonePWAHint() {
      let user_agent = window.navigator.userAgent;
      if (user_agent.match(/iPhone/i) && user_agent.match(/WebKit/i) && !window.navigator.standalone) {
        return true
      } else {
        return false
      }
    },
    showWaggons(){
      if (this.trainOpen === 'false') {
        this.trainOpen = 'true'
        this.trainMargin = 'margin-left: -50vmin'
        // width
        this.widthTakt= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
        this.widthCraftsman= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
        this.widthConstruction= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
        this.widthTime= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
        this.widthValue= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
        // work_packages
        this.workPackageWidthTakt= 'width: 12.81vmin',
        this.workPackageWidthCraftsman= 'width: 12.81vmin',
        this.workPackageWidthConstruction= 'width: 12.81vmin',
        this.workPackageWidthTime= 'width: 12.81vmin',
        this.workPackageWidthValue= 'width: 12.81vmin',
        // Font
        this.workPackageFontSizeColorTakt= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
        this.workPackageFontSizeColorCraftsman= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
        this.workPackageFontSizeColorConstruction= 'color: #212121; font-size: 2.145vmin; font-weight: bold'
        this.workPackageFontSizeColorTime= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
        this.workPackageFontSizeColorValue= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
      } else {
        this.trainOpen = 'false'
        if (this.activeWaggon === 'Takt') {
          this.trainMargin = 'margin-left: -50vmin'
          // width
          this.widthTakt= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          this.widthCraftsman= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthConstruction= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthTime= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthValue= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          // work_packages
          this.workPackageWidthTakt= 'width: 12.81vmin',
          this.workPackageWidthCraftsman= 'width: 0vmin',
          this.workPackageWidthConstruction= 'width: 0vmin',
          this.workPackageWidthTime= 'width: 0vmin',
          this.workPackageWidthValue= 'width: 0vmin',
          // Font
          this.workPackageFontSizeColorTakt= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
          this.workPackageFontSizeColorCraftsman= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorConstruction= 'color: #212121; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorTime= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorValue= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'

        } else if (this.activeWaggon === 'Craftsman') {
          this.trainMargin = 'margin-left: -34.8vmin'
          // width
          this.widthTakt= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthCraftsman= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          this.widthConstruction= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthTime= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthValue= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          // work_packages
          this.workPackageWidthTakt= 'width: 0vmin',
          this.workPackageWidthCraftsman= 'width: 12.81vmin',
          this.workPackageWidthConstruction= 'width: 0vmin',
          this.workPackageWidthTime= 'width: 0vmin',
          this.workPackageWidthValue= 'width: 0vmin',
          // Font
          this.workPackageFontSizeColorTakt= 'color: #F5F5F5; font-size: 0vmin'
          this.workPackageFontSizeColorCraftsman= 'color: #F5F5F5; font-size: 2.145vmin'
          this.workPackageFontSizeColorConstruction= 'color: #212121; font-size: 0vmin'
          this.workPackageFontSizeColorTime= 'color: #F5F5F5; font-size: 0vmin'
          this.workPackageFontSizeColorValue= 'color: #F5F5F5; font-size: 0vmin'
        } else if (this.activeWaggon === 'Construction') {
          this.trainMargin = 'margin-left: -19.6vmin'
          // width
          this.widthTakt= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthCraftsman= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthConstruction= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          this.widthTime= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthValue= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          // work_packages
          this.workPackageWidthTakt= 'width: 0vmin',
          this.workPackageWidthCraftsman= 'width: 0vmin',
          this.workPackageWidthConstruction= 'width: 12.81vmin',
          this.workPackageWidthTime= 'width: 0vmin',
          this.workPackageWidthValue= 'width: 0vmin',
          // Font
          this.workPackageFontSizeColorTakt= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorCraftsman= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorConstruction= 'color: #212121; font-size: 2.145vmin; font-weight: bold'
          this.workPackageFontSizeColorTime= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorValue= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
        } else if (this.activeWaggon === 'Time') {
          this.trainMargin = 'margin-left: -4.4vmin'
          // width
          this.widthTakt= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthCraftsman= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthConstruction= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthTime= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          this.widthValue= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          // work_packages
          this.workPackageWidthTakt= 'width: 0vmin',
          this.workPackageWidthCraftsman= 'width: 0vmin',
          this.workPackageWidthConstruction= 'width: 0vmin',
          this.workPackageWidthTime= 'width: 12.81vmin',
          this.workPackageWidthValue= 'width: 0vmin',
          // Font
          this.workPackageFontSizeColorTakt= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorCraftsman= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorConstruction= 'color: #212121; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorTime= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
          this.workPackageFontSizeColorValue= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
        } else if (this.activeWaggon === 'Value') {
          this.trainMargin = 'margin-left: 10.8vmin'
          // width
          this.widthTakt= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthCraftsman= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthConstruction= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthTime= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthValue= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          // work_packages
          this.workPackageWidthTakt= 'width: 0vmin',
          this.workPackageWidthCraftsman= 'width: 0vmin',
          this.workPackageWidthConstruction= 'width: 0vmin',
          this.workPackageWidthTime= 'width: 0vmin',
          this.workPackageWidthValue= 'width: 12.81vmin',
          // Font
          this.workPackageFontSizeColorTakt= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorCraftsman= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorConstruction= 'color: #212121; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorTime= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorValue= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
        }
      }
    },

    setWaggonActive(waggon){
      if (this.trainOpen === 'true') {
        this.activeWaggon = waggon
        this.trainOpen = 'false'
        if (this.activeWaggon === 'Takt') {
          this.trainMargin = 'margin-left: -50vmin'
          // width
          this.widthTakt= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          this.widthCraftsman= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthConstruction= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthTime= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthValue= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          // work_packages
          this.workPackageWidthTakt= 'width: 12.81vmin',
          this.workPackageWidthCraftsman= 'width: 0vmin',
          this.workPackageWidthConstruction= 'width: 0vmin',
          this.workPackageWidthTime= 'width: 0vmin',
          this.workPackageWidthValue= 'width: 0vmin',
          // Font
          this.workPackageFontSizeColorTakt= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
          this.workPackageFontSizeColorCraftsman= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorConstruction= 'color: #212121; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorTime= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorValue= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'

        } else if (this.activeWaggon === 'Craftsman') {
          this.trainMargin = 'margin-left: -34.8vmin'
          // width
          this.widthTakt= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthCraftsman= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          this.widthConstruction= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthTime= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthValue= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          // work_packages
          this.workPackageWidthTakt= 'width: 0vmin',
          this.workPackageWidthCraftsman= 'width: 12.81vmin',
          this.workPackageWidthConstruction= 'width: 0vmin',
          this.workPackageWidthTime= 'width: 0vmin',
          this.workPackageWidthValue= 'width: 0vmin',
          // Font
          this.workPackageFontSizeColorTakt= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorCraftsman= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
          this.workPackageFontSizeColorConstruction= 'color: #212121; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorTime= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorValue= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
        } else if (this.activeWaggon === 'Construction') {
          this.trainMargin = 'margin-left: -19.6vmin'
          // width
          this.widthTakt= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthCraftsman= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthConstruction= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          this.widthTime= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthValue= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          // work_packages
          this.workPackageWidthTakt= 'width: 0vmin',
          this.workPackageWidthCraftsman= 'width: 0vmin',
          this.workPackageWidthConstruction= 'width: 12.81vmin',
          this.workPackageWidthTime= 'width: 0vmin',
          this.workPackageWidthValue= 'width: 0vmin',
          // Font
          this.workPackageFontSizeColorTakt= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorCraftsman= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorConstruction= 'color: #212121; font-size: 2.145vmin; font-weight: bold'
          this.workPackageFontSizeColorTime= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorValue= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
        } else if (this.activeWaggon === 'Time') {
          this.trainMargin = 'margin-left: -4.4vmin'
          // width
          this.widthTakt= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthCraftsman= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthConstruction= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthTime= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          this.widthValue= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          // work_packages
          this.workPackageWidthTakt= 'width: 0vmin',
          this.workPackageWidthCraftsman= 'width: 0vmin',
          this.workPackageWidthConstruction= 'width: 0vmin',
          this.workPackageWidthTime= 'width: 12.81vmin',
          this.workPackageWidthValue= 'width: 0vmin',
          // Font
          this.workPackageFontSizeColorTakt= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorCraftsman= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorConstruction= 'color: #212121; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorTime= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
          this.workPackageFontSizeColorValue= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
        } else if (this.activeWaggon === 'Value') {
          this.trainMargin = 'margin-left: 10.8vmin'
          // width
          this.widthTakt= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthCraftsman= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthConstruction= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthTime= "width: 0vmin; margin-left: 0vmin; margin-right: 0vmin",
          this.widthValue= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          // work_packages
          this.workPackageWidthTakt= 'width: 0vmin',
          this.workPackageWidthCraftsman= 'width: 0vmin',
          this.workPackageWidthConstruction= 'width: 0vmin',
          this.workPackageWidthTime= 'width: 0vmin',
          this.workPackageWidthValue= 'width: 12.81vmin',
          // Font
          this.workPackageFontSizeColorTakt= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorCraftsman= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorConstruction= 'color: #212121; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorTime= 'color: #F5F5F5; font-size: 0vmin; font-weight: bold'
          this.workPackageFontSizeColorValue= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
        }
      } else {
        this.trainOpen = 'true'
        this.trainMargin = 'margin-left: -50vmin'
        // width
        this.widthTakt= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
        this.widthCraftsman= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
        this.widthConstruction= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
        this.widthTime= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
        this.widthValue= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
        // work_packages
        this.workPackageWidthTakt= 'width: 12.81vmin',
        this.workPackageWidthCraftsman= 'width: 12.81vmin',
        this.workPackageWidthConstruction= 'width: 12.81vmin',
        this.workPackageWidthTime= 'width: 12.81vmin',
        this.workPackageWidthValue= 'width: 12.81vmin',
        // Font
        this.workPackageFontSizeColorTakt= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
        this.workPackageFontSizeColorCraftsman= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
        this.workPackageFontSizeColorConstruction= 'color: #212121; font-size: 2.145vmin; font-weight: bold'
        this.workPackageFontSizeColorTime= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
        this.workPackageFontSizeColorValue= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
      }
      if (waggon === "Takt") {
        this.opacityStart = "opacity: 0"
        this.opacityTakt = "opacity: 1"
        this.opacityCraftsman = "opacity: 0"
        this.opacityConstruction = "opacity: 0"
        this.opacityTime = "opacity: 0"
        this.opacityValue = "opacity: 0"
      } else if (waggon === "Craftsman") {
        this.opacityStart = "opacity: 0"
        this.opacityTakt = "opacity: 0"
        this.opacityCraftsman = "opacity: 1"
        this.opacityConstruction = "opacity: 0"
        this.opacityTime = "opacity: 0"
        this.opacityValue = "opacity: 0"
      } else if (waggon === "Construction") {
        this.opacityStart = "opacity: 0"
        this.opacityTakt = "opacity: 0"
        this.opacityCraftsman = "opacity: 0"
        this.opacityConstruction = "opacity: 1"
        this.opacityTime = "opacity: 0"
        this.opacityValue = "opacity: 0"
      } else if (waggon === "Time") {
        this.opacityStart = "opacity: 0"
        this.opacityTakt = "opacity: 0"
        this.opacityCraftsman = "opacity: 0"
        this.opacityConstruction = "opacity: 0"
        this.opacityTime = "opacity: 1"
        this.opacityValue = "opacity: 0"
      } else if (waggon === "Value") {
        this.opacityStart = "opacity: 0"
        this.opacityTakt = "opacity: 0"
        this.opacityCraftsman = "opacity: 0"
        this.opacityConstruction = "opacity: 0"
        this.opacityTime = "opacity: 0"
        this.opacityValue = "opacity: 1"
      } else if (waggon === "Start") {
        this.opacityStart = "opacity: 1"
        this.opacityTakt = "opacity: 0"
        this.opacityCraftsman = "opacity: 0"
        this.opacityConstruction = "opacity: 0"
        this.opacityTime = "opacity: 0"
        this.opacityValue = "opacity: 0"
      }
    },
    getInfoBoxOpacity(infoBoxType){
      if (this.waggonOpacity !== 0) {
        var infoBox = ''
      if (infoBoxType === 'Takt') {
        infoBox = `${this.opacityTakt}`
      }
      if (infoBoxType === 'Craftsman') {
        infoBox = `${this.opacityCraftsman}`
      }
      if (infoBoxType === 'Construction') {
        infoBox = `${this.opacityConstruction}`
      }
      if (infoBoxType === 'Time') {
        infoBox = `${this.opacityTime}`
      }
      if (infoBoxType === 'Value') {
        infoBox = `${this.opacityValue}`
      }
      return infoBox
    } else {
      return 'opacity: 0'
    }
    },
    getWaggonOpacity(delay, waggontype){
      var waggon = ''
      if (waggontype === 'Train') {
        waggon = `opacity: ${this.waggonOpacity} ; transform: ${this.waggonTranslate};
        transition: transform 0.2s ${delay}`
      }
      if (waggontype === 'Takt') {
        waggon = `opacity: ${this.waggonOpacity} ; transform: ${this.waggonTranslate};
        transition: transform 0.2s ${delay}, width 0.2s ease-in-out; ${this.widthTakt}`
      }
      if (waggontype === 'Craftsman') {
        waggon = `opacity: ${this.waggonOpacity} ; transform: ${this.waggonTranslate};
        transition: transform 0.2s ${delay}, width 0.2s ease-in-out; ${this.widthCraftsman}`
      }
      if (waggontype === 'Construction') {
        waggon = `opacity: ${this.waggonOpacity} ; transform: ${this.waggonTranslate};
        transition: transform 0.2s ${delay}, width 0.2s ease-in-out; ${this.widthConstruction}`
      }
      if (waggontype === 'Time') {
        waggon = `opacity: ${this.waggonOpacity} ; transform: ${this.waggonTranslate};
        transition: transform 0.2s ${delay}, width 0.2s ease-in-out; ${this.widthTime}`
      }
      if (waggontype === 'Value') {
        waggon = `opacity: ${this.waggonOpacity} ; transform: ${this.waggonTranslate};
        transition: transform 0.2s ${delay}, width 0.2s ease-in-out; ${this.widthValue}`
      }
      return waggon
    },
    coverFlowShow(){
      if (window.scrollY === window.scrollMaxY) {
      // if (this.scrollDirection = 'down') {
        return true
      } else {
        return false
      }
    },

    getLogoOpacity(){
      return "opacity:" + this.logoOpacity
    },

    getImageOpacityTranslate(){

      let image = `opacity: ${this.imageOpacity} ; transform: ${this.imageTranslate}`
      return image
    },

    handleScroll () {
      if (this.scrolling === 0) {
      let previousScrollDirection = this.scrollDirection
      if (window.scrollY >= this.scrolled) {
        this.scrollDirection = "down"
      } else if (window.scrollY <= this.scrolled) {
        this.scrollDirection = "up"
      }
      if (previousScrollDirection !== this.scrollDirection) {
        if (this.scrollDirection === "down") {
          // window.scrollTo(0, window.scrollMaxY, smooth)
          // window.scrollTo({
          //   top: window.scrollMaxY,
          //   left: 0,
          //   behavior: 'smooth'
          // });
          // document.querySelector('#img').scrollTop = 0;
          this.trainOpen = 'true'
          this.trainMargin = 'margin-left: -50vmin'
          // width
          this.widthTakt= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          this.widthCraftsman= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          this.widthConstruction= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          this.widthTime= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          this.widthValue= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
          // work_packages
          this.workPackageWidthTakt= 'width: 12.81vmin',
          this.workPackageWidthCraftsman= 'width: 12.81vmin',
          this.workPackageWidthConstruction= 'width: 12.81vmin',
          this.workPackageWidthTime= 'width: 12.81vmin',
          this.workPackageWidthValue= 'width: 12.81vmin',
          // Font
          this.workPackageFontSizeColorTakt= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
          this.workPackageFontSizeColorCraftsman= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
          this.workPackageFontSizeColorConstruction= 'color: #212121; font-size: 2.145vmin; font-weight: bold'
          this.workPackageFontSizeColorTime= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
          this.workPackageFontSizeColorValue= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
          this.scrolling = 1
          this.logoOpacity = 0

          this.opacityArrowDown = 0
          this.opacityArrowUp = 0.5
          this.imageOpacity = 1
          this.imageTranslate = "translateY(0px)"
          this.waggonOpacity = 0.95
          this.waggonTranslate = "translateY(0px)"
          this.$vuetify.goTo('#endOfPage')
        } else if (this.scrollDirection === "up") {
          this.opacityArrowDown = 0.5
          this.opacityArrowUp = 0
          this.imageOpacity = 1
          this.imageTranslate = "translateY(100vh)"
          this.logoOpacity = 1
          this.waggonOpacity = 0
          this.waggonTranslate = "translateY(200px)"
          this.scrolling = 1
          this.$vuetify.goTo(0)
        }
      }
      this.scrolled = window.scrollY;
    }
  },

    // if (window.scrollY > 50) {
    //   this.$vuetify.goTo(400)
    // }

// handleScroll: function(evt, el) {
//  if (window.scrollY > 50) {
//      el.style.opacity = "0.5"
//  }
//  return window.scrollY > 100;
//  }
  doArrowLeft(){
    this.$router.push({name: 'Register'})
  },
  doArrowRight(){
    window.location.replace(process.env.VUE_APP_LOGIN_URL);
    // this.$router.push({name: 'Login'})

  },
  doArrowDown(){
    this.trainOpen = 'true'
    this.trainMargin = 'margin-left: -50vmin'
    // width
    this.widthTakt= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
    this.widthCraftsman= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
    this.widthConstruction= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
    this.widthTime= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
    this.widthValue= "width: 14.4vmin; margin-left: 0.4vmin; margin-right: 0.4vmin",
    // work_packages
    this.workPackageWidthTakt= 'width: 12.81vmin',
    this.workPackageWidthCraftsman= 'width: 12.81vmin',
    this.workPackageWidthConstruction= 'width: 12.81vmin',
    this.workPackageWidthTime= 'width: 12.81vmin',
    this.workPackageWidthValue= 'width: 12.81vmin',
    // Font
    this.workPackageFontSizeColorTakt= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
    this.workPackageFontSizeColorCraftsman= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
    this.workPackageFontSizeColorConstruction= 'color: #212121; font-size: 2.145vmin; font-weight: bold'
    this.workPackageFontSizeColorTime= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
    this.workPackageFontSizeColorValue= 'color: #F5F5F5; font-size: 2.145vmin; font-weight: bold'
    this.scrolling = 1
    this.scrollDirection = "down"
    this.logoOpacity = 0

    this.opacityArrowDown = 0
    this.opacityArrowUp = 0.5

    this.imageOpacity = 1
    this.imageTranslate = "translateY(0px)"
    this.waggonOpacity = 0.95
    this.waggonTranslate = "translateY(0px)"
    this.$vuetify.goTo('#endOfPage')
    // this.$vuetify.goTo(document.body.scrollHeight)
    // this.opacityArrowDown = 0
    // this.opacityArrowUp = 0.5
  },
  doArrowUp(){
    this.opacityArrowDown = 0.5
    this.opacityArrowUp = 0
    this.imageOpacity = 1
    this.imageTranslate = "translateY(100vh)"
    this.logoOpacity = 1
    this.waggonOpacity = 0
    this.waggonTranslate = "translateY(200px)"
    this.scrolling = 1
    this.scrollDirection = "up"
    this.$vuetify.goTo(0)

    // this.$vuetify.goTo(0)
    // this.opacityArrowUp = 0
    // this.opacityArrowDown = 0.5
  },
mouseOverDown(){
  if (this.scrollDirection === "down") {
    this.opacityArrowDown = 0
  } else {
    this.opacityArrowDown = 1
  }
},
mouseLeaveDown(){
  if (this.scrollDirection === "down") {
    this.opacityArrowDown = 0
  } else {
    this.opacityArrowDown = 0.5
  }
},
mouseOverUp(){
  if (this.scrollDirection === "up") {
    this.opacityArrowUp = 0
  } else {
    this.opacityArrowUp = 1
  }
},
mouseLeaveUp(){
  if (this.scrollDirection === "up") {
    this.opacityArrowUp = 0
  } else {
    this.opacityArrowUp = 0.5
  }
},
styleArrowDown(){
  if (this.scrollDirection === "down") {
    return `opacity: ${this.opacityArrowDown}`
  } else {
    return `opacity: ${this.opacityArrowDown}; z-index: 10`
  }
}

},
created () {
  window.addEventListener('scroll', this.handleScroll, {passive: true});
},
destroyed () {
  window.removeEventListener('scroll', this.handleScroll, {passive: true});
},
}

</script>

<style scoped>
/* Navigation Arrows */
/* Arrow allgemein */

.announcement{
  position: relative;
  left: 8.5vmin;
  top: -10vmin;
  font-size: 3.9vmin;
  color: black;
  font-weight: bold;
}
.logindialog {
  position:fixed;
  right: 50vw;
  top: 20vh;
  width: 90vmin;
  margin-right: -45vmin;
  /* animation-name: loginDialogSlideIn;
  animation-duration: 1s;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-timing-function: ease-out;
  animation-fill-mode: both;
  overflow: hidden;
  -moz-overflow:hidden; */
}
.arrow {
  position: fixed;
  width: 1.6vmin;
  height: 8vmin;
  border-radius: 1.6vmin;
  /* background: #9E9E9E; */
  background: #BDBDBD;
}
.arrow1 {
  margin-top: 0vmin;
  transition:
    background-color 0.1s ease-In-Out,
    width 0.1s ease-In-Out, height 0.1s ease-In-Out, border-radius 0.1s ease-In-Out,
    margin-left 0.1s ease-In-Out, margin-top 0.1s ease-In-Out, opacity 0.1s ease-In-Out,;
}
.arrow2 {
  transform: rotate(90deg);
  margin-left: 3.2vmin;
  margin-top: 3.2vmin;
  transition:
    background-color 0.1s ease-In-Out,
    width 0.1s ease-In-Out, height 0.1s ease-In-Out, border-radius 0.1s ease-In-Out,
    margin-left 0.1s ease-In-Out, margin-top 0.1s ease-In-Out, opacity 0.1s ease-In-Out,;
}

/* left */
.arrowleft{
  cursor: pointer;
  position: fixed;
  left: 2vw;
  top: 50vh;
  width: 8vmin;
  height: 8vmin;
  transform: rotate(45deg);
  z-index: 10;
  transition: opacity 0.1s ease-In-Out;
  /* animation-name: arrowsAppear; */
  /* animation-duration: 0.4s; */
  /* animation-delay: 7s; */
  /* animation-iteration-count: 1; */
  /* animation-direction: normal; */
  /* animation-timing-function: ease-in-out; */
  /* animation-fill-mode: both; */
}
.arrowleft:hover #left1 {
  background: #E0E0E0;
  width: 2vmin;
  height: 9vmin;
  border-radius: 2vmin;
  margin-left: -1vmin;
  margin-top: -0.5vmin;
}
.arrowleft:hover #left2 {
  background: #E0E0E0;
  width: 2vmin;
  height: 10vmin;
  border-radius: 2vmin;
  margin-left: 3vmin;
  margin-top: 3vmin;
}

/* right */
.arrowright{
  cursor: pointer;
  position: fixed;
  right: 2vw;
  top: 50vh;
  width: 8vmin;
  height: 8vmin;
  transform: rotate(225deg);
  z-index: 10;
  /* transition: opacity 0.1s ease-In-Out;
  animation-name: arrowsAppear;
  animation-duration: 0.4s;
  animation-delay: 7s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-timing-function: ease-in-out;
  animation-fill-mode: both; */
}
.arrowright:hover #right1 {
  background: #E0E0E0;
  width: 2vmin;
  height: 9vmin;
  border-radius: 2vmin;
  margin-left: -1vmin;
  margin-top: -0.5vmin;
}
.arrowright:hover #right2 {
  background: #E0E0E0;
  width: 2vmin;
  height: 10vmin;
  border-radius: 2vmin;
  margin-left: 3vmin;
  margin-top: 3vmin;
}

/* down */
.arrowdown{
  cursor: pointer;
  position: fixed;
  left: 48.5vw;
  bottom: calc(36px + 3.3vmin);
  width: 8vmin;
  height: 8vmin;
  transform: rotate(315deg);
  transition: opacity 0.1s ease-In-Out;
  animation-name: arrowsAppear;
  animation-duration: 0.4s;
  animation-delay: 7s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-timing-function: ease-in-out;
  animation-fill-mode: both;
}
.arrowdown:hover #down1 {
  background: #E0E0E0;
  width: 2vmin;
  height: 9vmin;
  border-radius: 2vmin;
  margin-left: -1vmin;
  margin-top: -0.5vmin;
}
.arrowdown:hover #down2 {
  background: #E0E0E0;
  width: 2vmin;
  height: 10vmin;
  border-radius: 2vmin;
  margin-left: 3vmin;
  margin-top: 3vmin;
}
/* up */
.arrowup{
  cursor: pointer;
  position: fixed;
  left: 48.5vw;
  top: calc(64px + 3.3vmin);
  width: 8vmin;
  height: 8vmin;
  transform: rotate(135deg);
  z-index: 10;
  transition: opacity 0.1s ease-In-Out;
}
.arrowup:hover #up1 {
  background: #E0E0E0;
  width: 2vmin;
  height: 9vmin;
  border-radius: 2vmin;
  margin-left: -1vmin;
  margin-top: -0.5vmin;
}
.arrowup:hover #up2 {
  background: #E0E0E0;
  width: 2vmin;
  height: 10vmin;
  border-radius: 2vmin;
  margin-left: 3vmin;
  margin-top: 3vmin;
}
.arrowup:hover #subscribe {
  margin-top: 10vmin;
}
/* Arrows Text */
.subscribe {
  margin-top: 8vmin;
  margin-left: 0.8vmin;
  transition: margin-top 0.1s ease-in-out, margin-left 0.1s ease-in-out;
  font-size: 1.5vmin;
}
.arrowleft:hover #subscribe {
  margin-top: 9vmin;
}
.login {
  transform: rotate(90deg);
  margin-top: 10vmin;
  margin-left: -9.8vmin;
  transition: margin-top 0.1s ease-in-out, margin-left 0.1s ease-in-out;
  font-size: 1.5vmin;
}
.arrowright:hover #login {
  margin-left: -11.8vmin;
  margin-top: 11vmin;
}
.more {
  margin-top: 8vmin;
  margin-left: 1.6vmin;
  transition: margin-top 0.1s ease-in-out, margin-left 0.1s ease-in-out;
  font-size: 1.5vmin;
}
.arrowdown:hover #more {
  margin-top: 9vmin;
}
.back {
  transform: rotate(-90deg);
  margin-top: -4.6vmin;
  margin-left: -10vmin;
  transition: margin-top 0.1s ease-in-out, margin-left 0.1s ease-in-out;
  font-size: 1.5vmin;
}
.arrowup:hover #back {
  margin-left: -11.8vmin;
  margin-top: -5.6vmin;
}
/* Infobox */
.infobox-waggon-frontpage {
  /* height: 66vmin;
  width: 99vmin; */
  height: 52.6vmin;
  width: 78.9vmin;
  border-radius: 5vmin;
  position: fixed;
  top: calc(64px + 10vmin);
  transition: opacity 1s ease-in-out;
}
.infobox-work_package1-frontpage {
  height: 54vmin;
  width: 81vmin;
  border-radius: 5vmin;
  margin: 0px 0px 0px 0px;
  /* Text */
  font-size: 2.145vmin;
  /* font-weight:  'bold'; */

  /* text non selectable */
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
   -khtml-user-select: none; /* Konqueror HTML */
     -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; /* Non-prefixed version, currently
                                supported by Chrome and Opera */
}
.infoBoxHeader {
  font-size: 9vmin;
  font-weight: bold;
  line-height: 15vmin;
  margin-top: 3vmin
}
.infoBoxSubheader {
  font-size: 3vmin;
  font-weight: bold;
  line-height: 4vmin;
  margin-top: 1vmin;
  margin-bottom: 3vmin
}
.infoBoxText {
  font-size: 3vmin
}

/* Waggons */
.coverflow {
  width: 100vmin;
  height: 9.6vmin;
  position: fixed;
  /* margin-top: 57vh;
  margin-left: 0vw; */
  bottom: 40px;
  left: 50vw;
  margin-left: -50vmin;
  transition: margin-left 0.2s ease-in-out;
}
.train-start-frontpage {
  cursor: pointer;
  float: left;
  height: 9.6vmin;
  width: 11.3vmin;
  border-radius: 100% 5% 5% 5%;
  margin-right: 0.4vmin;
  margin-left: 0.3vmin;
}
.train-end-frontpage {
  cursor: pointer;
  float: left;
  height: 9.6vmin;
  width: 11.3vmin;
  border-radius: 5% 100% 5% 5%;
  margin-left: 0.4vmin;
  margin-right: 0.3vmin;
}
.taktplan-waggon-frontpage {
  float: left;
  height: 9.6vmin;
  width: 14.4vmin;
  border-radius: 2.26vmin;
  margin-left: 0.4vmin;
  margin-right: 0.4vmin;
  /* transition: width 0.2s ease-in-out; */
}
/* .taktplan-waggon-frontpage:hover {
  float: left;
  height: 110px;
  width: 160px;
  border-radius: 20px;
} */

/* Workpackages in Taktplan*/
.taktplan-work_package1-frontpage {
  cursor: pointer;
  height: 8.54vmin;
  width: 12.81vmin;
  border-radius: 2.26vmin;
  margin: 0px 0px 0px 0px;
  /* Text */
  font-size: 2.145vmin;
  font-weight:  'bold';
/* text non selectable */
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
   -khtml-user-select: none; /* Konqueror HTML */
     -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; /* Non-prefixed version, currently
                                supported by Chrome and Opera */
}
.taktplan-work_package1-frontpage:hover {
  height: 9.6vmin;
  width: 14.4vmin;
  border-radius: 2.1vmin;
  font-size: 2.4vmin;
  font-weight:  'bold';
}
/* Background Image */
.imgContainer{
  /* margin-top: 120vh;
  margin-bottom: -10vh;
  margin-left: -10vw;
  width: 120vw;
  height: 100vh; */
  position: fixed;

  /* object-position: middle center; */
  top: 0;
  left: 0;
  transition: opacity 0.2s ease-in-out, transform 0.4s ease-In-Out;
  /* content: url(http://takting.com/img/frontpage_start.png); */
}
.image {
  filter: grayscale(100%);
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  /* object-fit: contain; */
  /* object-position: middle center; */
  transition: opacity 1s ease-in-out 0.2s;
}
.imgStart {
  /* content:url(http://takting.com/img/frontpage_start.png); */
}
.imgTakt {
  /* content:url(http://takting.com/img/frontpage_takt.png); */
}
.imgCraftsman {
  /* content:url(http://takting.com/img/frontpage_craftsman.png); */
}
.imgConstruction {
  /* content:url(http://takting.com/img/frontpage_construction.png); */
}
.imgTime {
  /* content:url(http://takting.com/img/frontpage_time.png); */
}
.imgValue {
  /* content:url(http://takting.com/img/frontpage_value.png); */
}

/* TakIng Logo */
.logo {
  width: 80vmin;
  height: 62vmin;
  margin-left: -40vmin;
  margin-top: -35vmin;
  position: fixed;
  top: 50%;
  left: 48.5vw;
  transition: opacity 1s linear;
}

.square {
  float:left;
  height: 100%;
  width: 5%;
  border-radius: 0.5vw;
  position: relative;
  top: -11.8vh;
  margin-left: 1%;
  animation-name: logoAppear;
  animation-duration: 1s;
  /* animation-delay: 2s; */
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-timing-function: ease-in-out;
  animation-fill-mode: both;
  overflow: hidden;
}

.square1 {
  float:none;
  margin-left: 0;
  height: 11.8vh;
  width: 100%;
  position: static;
  background-color: var(--v-primary-base);;
  animation-delay: 4.6s;
}

.square2 {
  width: 15%;
  margin-left: 6.9%;
  background-color: var(--v-primary-base);;
  animation-delay: 4.4s;
  /* transition: opacity 0.5s ease-in-out; */
}

.square3 {
  width: 12%;
  background-color: #3F51B5;
  animation-delay: 4.2s;
  /* transition: opacity 0.5s ease-in-out; */
}

.square4 {
  width: 9.6%;
  background-color: #2196F3;
  animation-delay: 4.0s;
  /* transition: opacity 0.5s ease-in-out; */
}

.square5 {
  width: 7.68%;
  background-color: #03A9F4;
  animation-delay: 3.8s;
  /* transition: opacity 0.5s linear; */
}

.square6 {
  width: 6.14%;
  background-color: #00BCD4;
  animation-delay: 3.6s;
  /* transition: opacity 0.5s linear; */
}

.square7 {
  width: 4.9152%;
  background-color: #009688;
  animation-delay: 3.4s;
  /* transition: opacity 0.5s linear; */
}

.square8 {
  width: 3.9322%;
  background-color: #4CAF50;
  animation-delay: 3.2s;
  /* transition: opacity 0.5s linear; */
}

.square9 {
  width: 3.1457%;
  background-color: #8BC34A;
  animation-delay: 3.0s;
  /* transition: opacity 0.5s linear; */
}

.square10 {
  width: 2.5166%;
  background-color: #CDDC39;
  animation-delay: 2.8s;
  /* transition: opacity 0.5s linear; */
}

.square11 {
  width: 2.0133%;
  background-color: #FFEB3B;
  animation-delay: 2.6s;
  /* transition: opacity 0.5s linear; */
}

.square12 {
  width: 1.6106%;
  background-color: #FFC107;
  animation-delay: 2.4s;
  /* transition: opacity 0.5s linear; */
}

.square13 {
  width: 1.2885%;
  background-color: #FF9800;
  animation-delay: 2.2s;
  /* transition: opacity 0.5s linear; */
}

.square14 {
  width: 1.0308%;
  background-color: #FF5722;
  animation-delay: 2.0s;
  /* transition: opacity 0.5s linear; */
}
.square15 {
  width: 0.8246%;
  background-color: #F44336;
  animation-delay: 1.8s;
  /* transition: opacity 0.5s linear; */
}

.square16 {
  width: 0.6597%;
  background-color: #E91E63;
  animation-delay: 1.6s;
  /* transition: opacity 0.5s linear; */
}

.square17 {
  width: 0.5278%;
  background-color: #9C27B0;
  animation-delay: 1.4s;
  /* transition: opacity 0.5s linear; */
}

.square18 {
  width: 0.4222%;
  background-color: #673AB7;
  animation-delay: 1.2s;
  /* transition: opacity 0.5s linear; */
}

.square19 {
  width: 0.3378%;
  background-color: #607D8B;
  animation-delay: 1.0s;
  /* transition: opacity 0.5s linear; */
}

.square20 {
  width: 0.2702%;
  background-color: #9E9E9E;
  animation-delay: 0.8s;
  /* transition: opacity 0.5s linear; */
}

.square21 {
  width: 0.2162%;
  background-color: #FFFFFF;
  animation-delay: 0.6s;
  /* transition: opacity 0.2s linear; */
}

/* old stuff */

.overlay{
  width: 100vw;
  height: 100vh;
  background: linear-gradient(0deg, black, white);
  position: absolute;
  z-index: 1;
  opacity: 0.1;
}

.waggon {
  width: 17%;
  height: 85%;
  float: left;
  margin-left: 1.5%;
  margin-right: 1.5%;
  margin-bottom: 5%;
  margin-top: 1%;
  border-radius: 1vw;

  transition-property: transform, opacity, width, height, margin-left, margin-right, margin-bottom, margin-top;
  transition-duration: 0.2s, 0.2s, 0.1s, 0.1s, 0.1s, 0.1s, 0.1s, 0.1s;
  transition-timing-function: ease-in-out;
  /* Text */
  text-align: center;
  vertical-align: middle;
  line-height: 90%;
  color: black;
  font-size: 200%;
  font-weight: bold;
  font-family: Helvetica;
  /* border-style: solid;
  border-width: 1px;
  border-color: #FAFAFA; */
  /* filter: grayscale(50%); */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

}
.waggon:hover {
  cursor: pointer;
  width: 20%;
  margin-left: 0%;
  margin-right: 0%;
  margin-bottom: 0%;
  margin-top: 0%;
  height: 100%;
  opacity: 1;
}
.waggontext{

}
.waggon1 {
 /* background-color: #3F51B5; */
 background: linear-gradient(0deg, #3F51B5, #7986CB);
 /* transition: transform 0.2s ease-In-Out 0s, opacity 0.2s ease-In-Out; */
 transition-delay: 0.3s, 0s, 0s, 0s, 0s, 0s, 0s, 0s;

}
.waggon2 {
 /* background-color: #4CAF50; */
 background: linear-gradient(0deg, #4CAF50, #81C784);
 /* transition: transform 0.2s ease-In-Out 0.05s, opacity 0.2s ease-In-Out; */
 transition-delay: 0.35s, 0s, 0s, 0s, 0s, 0s, 0s, 0s;
}
.waggon3 {
 /* background-color: #FFEB3B; */
 background: linear-gradient(0deg, #FFEB3B, #FFF176);
 /* transition: transform 0.2s ease-In-Out 0.1s, opacity 0.2s ease-In-Out; */
 transition-delay: 0.4s, 0s, 0s, 0s, 0s, 0s, 0s, 0s;
}
.waggon4 {
 /* background-color: #F44336; */
 background: linear-gradient(0deg, #F44336, #E57373);
 /* transition: transform 0.2s ease-In-Out 0.15s, opacity 0.2s ease-In-Out; */
 transition-delay: 0.45s, 0s, 0s, 0s, 0s, 0s, 0s, 0s;
}
.waggon5 {
 /* background-color: #9C27B0; */
background: linear-gradient(0deg, #9C27B0, #BA68C8);
/* transition: transform 0.2s ease-In-Out 0.2s, opacity 0.2s ease-In-Out; */
transition-delay: 0.5s, 0s, 0s, 0s, 0s, 0s, 0s, 0s;
}

/* .container .square {
  transform: translateX(300px);
} */

@keyframes logoAppear{
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes arrowsAppear{
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}
@keyframes loginDialogSlideIn{
  0% {
    right: 0vw;
  }
  100% {
    right: 50vw;
  }
}
</style>
